import {createFileRoute} from '@tanstack/react-router'
import {secondLevelIndexRoute} from "../../../../../../../utils/collectionListing";

export const Route = createFileRoute('/_site/users/_public_profile/notwant/$username/$primarySorting/$primaryCategoryName/')({
    ...secondLevelIndexRoute("/users/notwant/$username/$primarySorting/$primaryCategoryName/$secondaryCategoryName")
})
